// Validazione di UN campo del form-in-chat, per l'anteprima admin.
//
// GEMELLO di apps/backend/src/services/flow/utils/formValidation.js, che il widget
// di produzione riceve come testo (non può importare moduli). Le due copie devono
// dare lo stesso esito: gli stessi casi sono verificati in entrambi i test.
//
// entry: { type, required, value, min, max }
//   value: stringa, booleano (checkbox), null/undefined (nessuna selezione).
// labels: { required, min, max } — `min`/`max` possono contenere {min} / {max}.
// Ritorna il messaggio da mostrare, oppure null.
export function validateFormValue(entry, labels) {
  const e = entry || {};
  const L = labels || {};
  const type = e.type || 'text';
  const value = e.value;

  let empty;
  if (type === 'checkbox') empty = value !== true;
  else if (value == null) empty = true;
  else empty = String(value).trim() === '';

  if (e.required && empty) return L.required || 'Required field';
  if (empty) return null;

  if (type === 'number') {
    const n = Number(String(value).trim());
    if (!Number.isFinite(n)) return null;
    const hasMin = e.min != null && e.min !== '' && Number.isFinite(Number(e.min));
    const hasMax = e.max != null && e.max !== '' && Number.isFinite(Number(e.max));
    if (hasMin && n < Number(e.min)) {
      return String(L.min || 'The minimum value is {min}').replace('{min}', String(Number(e.min)));
    }
    if (hasMax && n > Number(e.max)) {
      return String(L.max || 'The maximum value is {max}').replace('{max}', String(Number(e.max)));
    }
  }

  return null;
}

// Etichette degli errori, prese dalle traduzioni dell'app.
//
// ⚠️ vue-i18n interpreta `{min}`/`{max}` come interpolazione e, se non gli si passa
// il valore, li CANCELLA: `t('form.validation.numberMin')` restituisce "Il valore
// minimo è " (verificato con vue-i18n 11). Qui il vincolo non è noto — lo conosce
// solo validateFormValue, che lo sostituisce nel messaggio — quindi passiamo il
// segnaposto come valore di se stesso: la stringa arriva intatta alla validazione.
export function formErrorLabels(t) {
  return {
    required: t('form.validation.required'),
    min: t('form.validation.numberMin', { min: '{min}' }),
    max: t('form.validation.numberMax', { max: '{max}' }),
  };
}

// ─── Messaggio visibile sul campo ────────────────────────────────────────────
// Gli stili del form sono inline (shadow DOM di Deep Chat), quindi il bordo rosso
// va scritto su element.style: una classe non avrebbe alcun effetto.

function visibleInput(field) {
  const wrap = field.closest && (field.closest('.newc-form-address') || field.closest('.newc-form-searchselect'));
  if (wrap) {
    return wrap.querySelector('.newc-form-address-input')
      || wrap.querySelector('.newc-form-searchselect-input')
      || field;
  }
  return field;
}

function errorSlot(field) {
  const wrap = (field.closest && (field.closest('.newc-form-address')
    || field.closest('.newc-form-searchselect')
    || field.closest('.newc-form-row'))) || field.parentElement;
  // Un campo senza wrapper dedicato (hidden, conversationId: figli diretti del
  // <form>, vedi formHtml.js) risolverebbe qui al FORM stesso, il cui
  // querySelector('.newc-form-error') prende lo slot del PRIMO campo — non il
  // suo, che non esiste. Niente wrapper reale → niente slot, mai quello altrui.
  if (wrap && wrap.classList && wrap.classList.contains('newc-form')) return null;
  return wrap ? wrap.querySelector('.newc-form-error') : null;
}

export function setFieldError(field, message) {
  const slot = errorSlot(field);
  if (slot) { slot.textContent = message; slot.style.display = 'block'; }
  field.classList.add('newc-form-invalid');
  const visible = visibleInput(field);
  if (visible) { visible.style.borderColor = '#dc2626'; visible.setAttribute('aria-invalid', 'true'); }
}

// Accetta sia il campo che porta il valore sia l'input visibile (l'evento 'input'
// arriva da quest'ultimo su address e searchselect).
export function clearFieldError(el) {
  const slot = errorSlot(el);
  if (slot) { slot.textContent = ''; slot.style.display = 'none'; }
  const wrap = el.closest && (el.closest('.newc-form-address') || el.closest('.newc-form-searchselect'));
  const holder = wrap ? wrap.querySelector('.newc-form-field, .newc-array-field') : el;
  if (holder) holder.classList.remove('newc-form-invalid');
  const visible = visibleInput(holder || el);
  if (visible) { visible.style.borderColor = ''; visible.removeAttribute('aria-invalid'); }
}
